import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { take } from 'rxjs';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Portfolio } from '../../../models/portfolio';
import { PortfolioService } from '../../../services/PortfolioService';
import { StorePortfolioResponse } from '../../../responses/storePortfolioResponse';


@Component({ standalone: false,
  selector: 'edit-portfolio-dialog',
  templateUrl: 'edit-portfolio-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['edit-portfolio-dialog.component.scss']
})
export class EditPortfolioDialogComponent {
  public title: string= "Edit Portfolio";
  public message?: string;
  public confirmButtonText = "Save";
  public cancelButtonText = "Cancel";

  public editForm: FormGroup;

  public allowInactive: boolean=true;
  public portfolio!: Portfolio;
  
  public busy:boolean=false;
  public resultCode?:number;
  public resultText:string='';

  public editMode=false;
  public statusOptions = [
    { value: 'active', label: 'Active' },
    { value: 'inactive', label: 'Inactive' },
    { value: 'pending', label: 'Pending' }
  ];

  constructor(@Inject(MAT_DIALOG_DATA) data: any, private dialogRef: MatDialogRef<EditPortfolioDialogComponent>, private portfolioService:PortfolioService, private snackBar: MatSnackBar) {
    this.editForm = new FormGroup({
      name: new FormControl<string | undefined>(undefined, Validators.compose([Validators.required, Validators.maxLength(256)])),
    });
    if(data){
      this.portfolio=data.portfolio;
    }
  }

  ngOnInit(){
   
    if(this.portfolio) {
        this.presetValues();
    }
    else {
      this.title = "New Portfolio";
      //this.editForm.get('name').setValue(this.portfolioService.getUnusedPortfolioName());
      //this.editForm.get('name').markAsDirty();
    }
  }
   get name()         { return this.editForm.controls.name; }

  private presetValues(){
    this.editForm.get('name')!.setValue(this.portfolio.name);
  }

  get portfolioNameExists(){
    return this.portfolioService.portfolioNameExists(this.editForm.get('name')!.value, this.portfolio?.id);
  }

  get canSubmit(){
    return !this.busy && this.editForm.dirty && this.editForm.valid && !this.portfolioNameExists;
  }

  get canCancel(){
    return !this.busy;
  }

  public onCancelClick(): void {
    this.dialogRef.close(undefined);
  }

  public onConfirmClick(): void {
    this.busy=true;
    let tempP = this.createTempPortfolio();
    this.portfolioService.storePortfolio(tempP).pipe(take(1)).subscribe(r=>this.processResponse(r));
  }

  private createTempPortfolio(){
    let tempP= Object.assign(new Portfolio,this.portfolio); //copy original and then update attributes on copy
    tempP.name = this.editForm.get('name')!.value;
    return tempP;
  }

  private processResponse(r:StorePortfolioResponse){
    this.busy=false;
    if(r.success){
      this.snackBar.open('Portfolio "' + r.portfolio!.name + '" has been saved.', '×', {
        verticalPosition: 'top',
        duration: 5000 
      });
      this.dialogRef.close(r.portfolio);
    }
    else{
      this.snackBar.open('Saving portfolio failed: ' + r.message, '×', { panelClass: ['warn-snackbar'], verticalPosition: 'top'});
    }
  }
}

